import { useDispatch, useSelector } from "react-redux";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import {
  FormResetData,
  clearTeamsFilterListData,
  createTeamsListSave,
  deleteSingleAndGroupTeamListingDetails,
  getDetailsEditForm,
  getLevel,
  getLocationLists,
  getTeamFilterLists,
} from "./action";
import useSessionStorage from "../../hooks/useSessionStorage";
import { useEffect, useMemo, useRef, useState } from "react";
import useConfiguration from "../../hooks/useConfiguration";
import Spinner from "../common/Spinner/spinner";
import { teamsSelector } from "./selector";
import {
  formReset,
  setEditMultiSelectForm,
  setLoadingFlagDecrement,
  setLoadingFlagIncrement,
  updateFileld,
} from "./slice";
import { useLocation, useNavigate } from "react-router-dom";
import PaginationWithUISide from "../common/Modal/paginationWithUISide";
import { toast } from "react-toastify";
import Multiselect from "../common/TextField/dropDown";
import DropDown from "../common/SearchableSelect";
import { loginSelector } from "../Login/selector";
import { fetchDepsUnits } from "../Login/action";

const CreateTeam = () => {
  // Navigate
  const navigate = useNavigate();

  // Use Location hook use to get a details
  const location = useLocation();

  // redux dispatch initialize
  const dispatch = useDispatch();

  // Initailize location state
  const { pageTitle, team, saveTitle } = location.state || "";

  // Teams Selector get a data
  const { loadingFlag, teamsFormInputValues, data, level } =
    useSelector(teamsSelector);

  // Login Selector get a data
  const { depsUnitsMaster } = useSelector(loginSelector);

  // Location dropdown initial state
  const [locationLists, setLocationLists] = useState([]);

  // config use to BaseURL
  const config = useConfiguration();

  // Session storage items handling
  const storage = useSessionStorage();

  // get from Login details
  const login = storage.getItem("login");

  // edit flow fetch initilize
  const [multiSelectList, setMultiSelectDropdownList] = useState([]);

  // edit flow fetch initialize
  const [levelSelectList, setLevelSelectDropdownList] = useState([]);

  // Modal popup show
  const [showTeamsFilterPopup, setShowTeamsFilterPopup] = useState(false);

  // popup selected items initialize state
  const [tempSelectedItems, setTempSelectedItems] = useState([]);

  // selected item after store array
  const [selectedItems, setSelectedItems] = useState([]);

  // popup search initial State
  const [searchTerm, setSearchTerm] = useState("");

  // error initialize
  const [searchError, setSearchError] = useState("");

  // Error form data
  const [errors, setErrors] = useState({});

  // Multiselect dropdown Master data reset
  const leveldropdownList = useRef();
  const deptdropdownist = useRef();

  //   // Search results handle
  const handleSearchTeamsFilterTableList = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
  };

  useEffect(() => {
    setTempSelectedItems(selectedItems);
  }, [selectedItems]);

  // Close popup
  const ClosePopup = () => {
    setShowTeamsFilterPopup(false);
    setCurrentPage(1);
  };

  // handleChange for Input data
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // Check if the input type is a checkbox
    if (type === "checkbox") {
      dispatch(updateFileld({ field: name, value: checked }));
    } else if (name === 'locationName') {
      setSelectedItems([]);
      dispatch(updateFileld({ field: name, value }));
    }
    else {
      dispatch(updateFileld({ field: name, value }));
    }
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const updateLevels = (target) => {
    const value = target.value;
    if(target.name === "level") {
    dispatch(updateFileld({ field: "level", value }));
    } else if (target.name === "departmentList") {
      dispatch(updateFileld({ field: "departmentList", value }));
    }
    setSelectedItems([]);
  };

  // Multiselect dropdown handle
  const updateStstusDropVal = (target) => {
    // Initilize department values
    let deptValues = [...teamsFormInputValues?.departmentList];
    // Department dropdown handle
    if (target.name === "departmentList") {
      if (target.action === "add") {
        deptValues.push(target.value);
        setSelectedItems([]);
      } else if (target.action === "remove") {
        deptValues = deptValues?.filter(
          (item) => item?.id !== target?.value?.id
        );
        setSelectedItems([]);
      }
      dispatch(updateFileld({ field: "departmentList", value: deptValues }));
    }
  };
  // handle change for popup
  const handleCheckboxValues = (isChecked, item) => {
    if (isChecked) {
      if (
        !tempSelectedItems.some(
          (selectedItem) =>
            selectedItem.candidateUniqueId === item.candidateUniqueId
        )
      ) {
        setTempSelectedItems((prevSelectedItems) => [
          ...prevSelectedItems,
          item,
        ]);
      }
    } else {
      // If the checkbox is unchecked, remove the item from the tempSelectedItems array
      setTempSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter(
          (selectedItem) =>
            selectedItem.candidateUniqueId !== item.candidateUniqueId
        )
      );
    }
  };

  // handle save popup
  const handleAddClick = () => {
    setSelectedItems(tempSelectedItems);
    setShowTeamsFilterPopup(false);
  };

  // Validation Part
  const validation = (flag) => {
    // Error Initialized
    let tempErrors = {};
    let formIsValid = true;
    // location Validate
    if (!teamsFormInputValues.locationName) {
      formIsValid = false;
      tempErrors.locationName = "This field is required";
    }
    // level multiselect dropdown validate
    if (teamsFormInputValues.level?.length === 0) {
      formIsValid = false;
      tempErrors.level = "This field is required";
    }
    // departmentList validate
    if (teamsFormInputValues.departmentList?.length === 0) {
      formIsValid = false;
      tempErrors.departmentList = "This field is required";
    }
    // teams name Validate
    if (flag === true) {
      if (!teamsFormInputValues.teamName) {
        formIsValid = false;
        tempErrors.teamName = "This field is required";
      } else if (teamsFormInputValues.teamName.length >= 36) {
        formIsValid = false;
        tempErrors.teamName = "Maximum 35 characters only!";
      }
    }
    // Single dropdown and text box error
    setErrors(tempErrors);
    // Multiselect dropdown error
    if (Object.keys(tempErrors).length) {
      return false;
    } else {
      return true;
    }
  };

  // handleSubmit for Form data
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validation()) {
      // Save Method API CALL
      handleSearchTeamsFilterList();
      setShowTeamsFilterPopup(true);
    }
  };

  // Location, Level and department Master data
  useEffect(() => {
    if (config.baseUrl) {
      const jobCatIdListParams =
        login?.jobTypeFlags?.jobTypeList?.length > 0
          ? login?.jobTypeFlags?.jobTypeList?.map((item) => item?.jobTypeId)
          : [];
      dispatch(getLocationLists(config.baseUrl, login.employerUniqueId)).then(
        (response) => setLocationLists(response)
      );
      dispatch(getLevel(config.baseUrl, jobCatIdListParams));

      dispatch(fetchDepsUnits({ baseUrl: config.baseUrl }));
      if (!team) {
        setSelectedItems([]);
        dispatch(formReset())
      }
    }
  }, [config.baseUrl, team]);

  // Search results API Call
  const handleSearchTeamsFilterList = () => {
    if (config.baseUrl) {
      // const deptCanId =
      //   teamsFormInputValues.departmentList?.length > 0
      //     ? teamsFormInputValues?.departmentList?.map((item) => item.id)
      //     : [];
      const params = {
        page: 0,
        pageSize: 0,
        sortOrder: "string",
        sortColumn: "string",
        name: searchTerm,
        locationId: teamsFormInputValues.locationName,
        jobCategoryId: teamsFormInputValues.level.id,
        candidateDepartmentId: teamsFormInputValues?.departmentList?.id,
      };
      dispatch(getTeamFilterLists(config.baseUrl, params));
      setSearchError("");
      setSearchTerm("");
    }
  };

  // Call Create Teams API Call
  const createTeams = () => {
    // Check the Storage Items List
    if (selectedItems?.length > 0 && validation(true)) {
      const candidateUniqueId = selectedItems?.map(
        (item) => item?.candidateUniqueId
      );
      // const deptCanId =
      //   teamsFormInputValues.departmentList?.length > 0
      //     ? teamsFormInputValues?.departmentList?.map((item) => item.id)
      //     : [];

      const createParams = {
        locationid: teamsFormInputValues?.locationName,
        teamName: teamsFormInputValues?.teamName,
        isActive: teamsFormInputValues?.isActive,
        candidateUniqueId: candidateUniqueId,
        jobCategoryId: teamsFormInputValues.level.id,
        candidateDepartmentId: teamsFormInputValues.departmentList.id,
      };

      const updateparams = {
        candidateTeamId: team ? team.candidateTeamId : "",
        locationId: teamsFormInputValues?.locationName,
        teamName: teamsFormInputValues?.teamName,
        isActive: teamsFormInputValues?.isActive,
        candidateUniqueId: candidateUniqueId,
        jobCategoryId: teamsFormInputValues.level.id,
        candidateDepartmentId: teamsFormInputValues.departmentList.id,
      };
      // Create teams API Call
      if (!team) {
        dispatch(
          createTeamsListSave(
            `${config.baseUrl}/TeamScheduling/create-team`,
            createParams,
            true
          )
        ).then((res) => {
          if (res === "Team Name Already Exists!") {
          } else {
            setTimeout(() => {
              navigate("/listteams");
              setSelectedItems([]);
              dispatch(formReset());
              leveldropdownList?.current?.resetSelectedValues();
              deptdropdownist?.current?.resetSelectedValues();
            }, 1200);
          }
        });
      } else {
        // Update teams API Call
        dispatch(
          createTeamsListSave(
            `${config.baseUrl}/TeamScheduling/update-team`,
            updateparams,
            false
          )
        ).then((res) => {
          if (res === "Team Name Already Exists!") {
          } else {
            setTimeout(() => {
              navigate("/listteams");
              setSelectedItems([]);
              dispatch(formReset());
              leveldropdownList?.current?.resetSelectedValues();
              deptdropdownist?.current?.resetSelectedValues();
            }, 1200);
          }
        });
      }
    } else {
      if (validation(true)) {
        toast.warn("Atleast add one candidate");
      }
    }
  };

  // While click the Cancel button Reset the entire page
  const teamsPageCancel = () => {
    if (!team) {
      setSelectedItems([]);
      dispatch(formReset());
    } else {
      navigate("/listteams");
    }
  };

  // Update Details Fetch the page
  useEffect(() => {
    if (team) {
      setSelectedItems(team.candidatesTeamMember);
      leveldropdownList?.current?.resetSelectedValues();
      deptdropdownist?.current?.resetSelectedValues();
    } else {
      setSelectedItems([]);
      dispatch(formReset());
      leveldropdownList?.current?.resetSelectedValues();
      deptdropdownist?.current?.resetSelectedValues();
    }
  }, []);

  // Delete a Respected rows from session storage
  const deleteRowList = (candidateUniqueId, candidateTeamMemberId) => {
    if (!team) {
      // Remove the row with the specified id from teamsSelectedRows
      const updatedRows = selectedItems?.filter(
        (row) => row.candidateUniqueId !== candidateUniqueId
      );
      setSelectedItems(updatedRows);
      toast.success("Candidate is removed from this team successfully!");
    } else {
      const updatedRows = selectedItems?.filter(
        (row) => row.candidateUniqueId !== candidateUniqueId
      );
      setSelectedItems(updatedRows);
      if (!candidateTeamMemberId) {
        toast.success("Candidate is removed from this team successfully!");
      }
      if (candidateTeamMemberId) {
        dispatch(
          deleteSingleAndGroupTeamListingDetails(
            `${config.baseUrl}/TeamScheduling/delete-team-member?CandidateTeamMemberId=${candidateTeamMemberId}`
          )
        );
      }
    }
  };

  useEffect(() => {
    if (team && depsUnitsMaster) {
      // const filterDepartment = team.candidateDepartmentIdList
      //   ? depsUnitsMaster.filter((obj) =>
      //       team.candidateDepartmentIdList.includes(obj.id)
      //     )
      //   : [];
      const filterDepartment = depsUnitsMaster.filter(
        (obj) => obj.id === team.candidateDepartmentId
      );
        const filteredLevel = level.filter(
          (obj) => obj.id === team?.jobCategoryId
        );
      setLevelSelectDropdownList(filteredLevel)
      setMultiSelectDropdownList(filterDepartment);
    }
  }, [team && depsUnitsMaster]);

  useEffect(() => {
    try {
      dispatch(setLoadingFlagIncrement());
      // team && dispatch(getDetailsEditForm(team, ...multiSelectList));
      team && dispatch(getDetailsEditForm(team, ...levelSelectList, ...multiSelectList));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  }, [multiSelectList]);

  // UI Side Pagination Section
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageNum, setCurrentPageNum] = useState(1);
  const [goTo, setGoTo] = useState("");
  const dataPerPage = useRef(20);
  const pageNumber = [];
  for (
    let i = 1;
    i < Math.ceil(data?.teamSchedulingList?.length / dataPerPage.current) + 1;
    i++
  ) {
    pageNumber.push(i);
  }
  const indexOfLastItem = dataPerPage.current * currentPage;
  const indexOfCurrentItem = indexOfLastItem - dataPerPage.current;
  const TeamSearchCandidatesResults = data?.teamSchedulingList?.slice(
    indexOfCurrentItem,
    indexOfLastItem
  );

  return (
    <>
      {/* Loading Flag */}
      {loadingFlag > 0 && <Spinner />}
      <Header />
      <Sidebar />
      {showTeamsFilterPopup && (
        <PaginationWithUISide
          showHide={ClosePopup}
          label={"Search Candidates Results"}
          size="xl"
          onlyClose={true}
          modalClass={"rounded-2"}
          pageNumber={pageNumber}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          currentPageNum={currentPageNum}
          setCurrentPageNum={setCurrentPageNum}
          setGoTo={setGoTo}
          goTo={goTo}
          save={tempSelectedItems?.length > 0 ? true : false}
          close={tempSelectedItems?.length > 0 ? true : false}
          saveName={"Add"}
          closeName={"Close"}
          handleSave={handleAddClick}
          pagination={true}
        >
          <div className="card-body">
            <div>
              <ul className="list-group ">
                <div class="input-group mb-3 w-25">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search name here"
                    onChange={handleSearchTeamsFilterTableList}
                  />
                  <span
                    class="input-group-text bg-white btn border  border-end"
                    onClick={handleSearchTeamsFilterList}
                  >
                    {" "}
                    <i
                      className="fe fe-search text-dark"
                      aria-hidden="true"
                    ></i>
                  </span>
                </div>
                {searchError && (
                  <span className="text-danger"> {searchError}</span>
                )}

                {TeamSearchCandidatesResults?.length > 0 ? (
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th style={{ textTransform: "none" }}>Name</th>
                        <th style={{ textTransform: "none" }}>Email</th>
                        <th style={{ textTransform: "none" }}>
                          Location Status
                        </th>
                        <th style={{ textTransform: "none" }}>Level</th>
                        <th style={{ textTransform: "none" }}>Department</th>
                      </tr>
                    </thead>
                    <tbody>
                      {TeamSearchCandidatesResults?.map((item) => (
                        <tr key={item.candidateUniqueId}>
                          <td>
                            <input
                              type="checkbox"
                              className="form-check-input ms-2"
                              checked={tempSelectedItems.some(
                                (selectedItem) =>
                                  selectedItem.candidateUniqueId ===
                                  item.candidateUniqueId
                              )}
                              onChange={(e) =>
                                handleCheckboxValues(e.target.checked, item)
                              }
                            />
                          </td>
                          <td>{item.fullName}</td>
                          <td>{item.emailAddress}</td>
                          <td>{item.statusOFLocation}</td>
                          <td>{item.jobLevel}</td>
                          <td>{item.departmentName 
                          // && item.departmentName?.map((item) => (
                          //   <span>{item}<br/></span>
                          // ))
                          }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th style={{ textTransform: "none" }}>Name</th>
                          <th style={{ textTransform: "none" }}>Email</th>
                          <th style={{ textTransform: "none" }}>
                            Location Status
                          </th>
                          <th style={{ textTransform: "none" }}>Level</th>
                          <th style={{ textTransform: "none" }}>Department</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                    <h2 className="text-center">No Candidates Found</h2>
                  </div>
                )}
              </ul>
            </div>
          </div>
        </PaginationWithUISide>
      )}

      <div className="page main-margin">
        <div className="page-main">
          <div className="main-content app-content mt-0 main-background">
            <div className="side-app">
              <div className="main-container container-fluid">
                <div className="page-header">
                  <h1 className="page-title">
                    {pageTitle ? pageTitle : "Create Team"}
                  </h1>
                  {team && (
                    <button
                      className="btn btn-primary"
                      onClick={() => navigate("/listteams")}
                    >
                      Back
                    </button>
                  )}
                </div>
                <div class="card">
                  <div class="card-body">
                    <div class="panel panel-primary">
                      <form onSubmit={handleSubmit}>
                        <div className="row d-flex gap-3">
                          <div className="d-flex flex-column">
                            {/* Location dropdown */}
                            <span>
                              Location <span className="text-danger">*</span>
                            </span>
                            <div className="d-flex flex-column">
                              <select
                                disabled={team && true}
                                className="form-select w-50"
                                name="locationName"
                                onChange={handleChange}
                                value={teamsFormInputValues.locationName}
                              >
                                <option value={""}>-- Select --</option>
                                {locationLists.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                              {/* Location dropdown error */}
                              {
                                <span className="text-danger">
                                  {errors.locationName}
                                </span>
                              }
                            </div>
                          </div>
                          <div className="d-flex flex-column">
                            {/* Team name */}
                            <span>
                              Team Name <span className="text-danger">*</span>
                            </span>
                            <input
                              className="form-control w-50"
                              onChange={handleChange}
                              name="teamName"
                              value={teamsFormInputValues.teamName}
                            />
                            {/* Team name error */}
                            {
                              <span className="text-danger">
                                {errors.teamName}
                              </span>
                            }
                            <div className="d-flex flex-column gap-3 mt-3">
                              <div className="mt-2 mx-2">
                                <input
                                  type="checkbox"
                                  name="isActive"
                                  value={teamsFormInputValues.isActive}
                                  onChange={handleChange}
                                  checked={
                                    teamsFormInputValues.isActive ? true : false
                                  }
                                />
                                Active
                              </div>
                              <div className="w-50">
                                <DropDown
                                  name={"level"}
                                  label={"Levels"}
                                  placeholder={"Select"}
                                  star={"*"}
                                  options={level}
                                  multiple={false}
                                  value={
                                    teamsFormInputValues.level
                                      ? [teamsFormInputValues.level]
                                      : []
                                  }
                                  updateValue={updateLevels}
                                  isObject={true}
                                  showArrow={true}
                                  divClass={"me-1 mx-1 bottom-drop"}
                                  errors={
                                    errors["level"] ? [errors["level"]] : ""
                                  }
                                />
                              </div>
                              <div className="w-50">
                                {/* <Multiselect
                                  name={"departmentList"}
                                  label={"Departments"}
                                  star={"*"}
                                  placeholder={"Select Departments"}
                                  value={teamsFormInputValues.departmentList}
                                  updateValue={updateStstusDropVal}
                                  options={depsUnitsMaster}
                                  multiselectRef={deptdropdownist}
                                  showArrow={true}
                                  isObject={true}
                                  multiple={true}
                                  errors={
                                    errors["departmentList"]
                                      ? [errors["departmentList"]]
                                      : ""
                                  }
                                  divClass="me-1 mx-1 "
                                /> */}
                                 <DropDown
                                  name={"departmentList"}
                                  label={"Departments"}
                                  placeholder={"Select"}
                                  star={"*"}
                                  options={depsUnitsMaster}
                                  multiple={false}
                                  value={
                                    teamsFormInputValues.departmentList
                                      ? [teamsFormInputValues.departmentList]
                                      : []
                                  }
                                  updateValue={updateLevels}
                                  isObject={true}
                                  showArrow={true}
                                  divClass={"me-1 mx-1 bottom-drop"}
                                  errors={
                                    errors["departmentList"]
                                      ? [errors["departmentList"]]
                                      : ""
                                  }
                                />
                              </div>
                              <div className="d-flex flex-column">
                                <button className="btn btn-primary w-25">
                                  Display Authorized Candidates
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                {/* Session Storage Items Showing CARD */}
                {selectedItems?.length > 0 ? (
                  <div class="card">
                    <div class="card-body">
                      <div class="panel panel-primary">
                        <table className="table">
                          <thead>
                            <tr>
                              <th style={{ textTransform: "none" }}>Name</th>
                              <th style={{ textTransform: "none" }}>Email</th>
                              <th style={{ textTransform: "none" }}>
                                Location Status
                              </th>
                              <th style={{ textTransform: "none" }}>Level</th>
                              <th style={{ textTransform: "none" }}>Department</th>
                              <th style={{ textTransform: "none" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedItems?.map((item) => (
                              <tr key={item.candidateUniqueId}>
                                <td>{item.fullName}</td>
                                <td>{item.emailAddress}</td>
                                <td>{item.statusOFLocation}</td>
                                <td>{item.jobLevel}</td>
                                <td>{item.departmentName 
                                // && item.departmentName?.map((item) => (
                                //   <span>{item}<br/></span>
                                // ))
                                }</td>
                                <td>
                                  {/* Delete a respective rows */}
                                  <i
                                    onClick={() =>
                                      deleteRowList(
                                        item.candidateUniqueId,
                                        item.candidateTeamMemberId
                                      )
                                    }
                                    className="fe fe-trash-2 fa-lg"
                                    style={{ cursor: "pointer" }}
                                  ></i>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div className="d-flex justify-content-end gap-2">
                          <button
                            className="btn btn-primary"
                            onClick={() => createTeams()}
                          >
                            {saveTitle ? saveTitle : `Create Team`}
                          </button>
                          <button
                            className="btn btn-outline-primary"
                            onClick={() => teamsPageCancel()}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{height: '180px'}}>
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      className="btn btn-primary"
                      onClick={() => createTeams()}
                    >
                      {saveTitle ? saveTitle : `Create Team`}
                    </button>
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => teamsPageCancel()}
                    >
                      Cancel
                    </button>
                  </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateTeam;
